import { FC } from 'react'
import { faTools, faExclamationTriangle, faSortDown, faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'

type IconProps = Omit<FontAwesomeIconProps, 'icon'>

export const ToolsIcon: FC<IconProps> = ({ size = 'xs' }: IconProps) => <FontAwesomeIcon icon={faTools} size={size} />
export const WarningIcon: FC<IconProps> = ({ size = '1x' }: IconProps) => <FontAwesomeIcon icon={faExclamationTriangle} size={size} />
export const SortDownIcon: FC<IconProps> = ({ size = '1x' }: IconProps) => <FontAwesomeIcon icon={faSortDown} size={size} />
export const StarIcon: FC<IconProps> = ({ size = '1x' }: IconProps) => <FontAwesomeIcon icon={faStar} size={size} />